export default "__VITE_ASSET__C9WkaVU4__"